export const RESOURCES_BASE_PATH = "/Resources";
export const RESOURCES_SCHEDULES_PATH = `${RESOURCES_BASE_PATH}/schedules`;
export const RESOURCES_TRADING_PARTNERS_PATH = `${RESOURCES_BASE_PATH}/trading-partners`;
export const RESOURCES_PARTNER_GROUPS_PATH = `${RESOURCES_BASE_PATH}/partner-groups`;
export const RESOURCE_GROUP_BASE_PATH = `${RESOURCES_BASE_PATH}/group`;
export const RESOURCE_WORKSPACE_BASE_PATH = `${RESOURCES_BASE_PATH}/resource`;
export const RESOURCE_NAVIGATION_TARGET_KEY = "/resources/";

export const encodeResourceRouteSegment = (value) => encodeURIComponent(value);

export const buildResourceWorkspacePath = (clientResourceId, toolKey = "") => {
  if (!clientResourceId) return RESOURCES_BASE_PATH;
  const basePath = `${RESOURCE_WORKSPACE_BASE_PATH}/${encodeResourceRouteSegment(clientResourceId)}`;
  return toolKey ? `${basePath}/${encodeResourceRouteSegment(toolKey)}` : basePath;
};

export const buildResourceGroupPath = (groupKey) =>
  groupKey ? `${RESOURCE_GROUP_BASE_PATH}/${encodeResourceRouteSegment(groupKey)}` : RESOURCES_BASE_PATH;

export const buildResourceConfigurationManagePath = (clientResourceId) =>
  clientResourceId
    ? `${RESOURCE_WORKSPACE_BASE_PATH}/${encodeResourceRouteSegment(clientResourceId)}/configurations/manage`
    : RESOURCES_BASE_PATH;

export const buildResourceConfigurationWorkspacePath = (clientResourceId, resourceConfigurationId) =>
  clientResourceId && resourceConfigurationId
    ? `${RESOURCE_WORKSPACE_BASE_PATH}/${encodeResourceRouteSegment(clientResourceId)}/configurations/${encodeResourceRouteSegment(resourceConfigurationId)}`
    : buildResourceWorkspacePath(clientResourceId);

export const buildResourceConfigurationWorkspaceScreenPath = (clientResourceId, resourceConfigurationId, screenKey = "") => {
  const basePath = buildResourceConfigurationWorkspacePath(clientResourceId, resourceConfigurationId);
  return screenKey ? `${basePath}/${encodeResourceRouteSegment(screenKey)}` : basePath;
};

export const buildResourceConfigurePath = (clientResourceId, resourceConfigurationId) => {
  if (!clientResourceId) return "";
  const basePath = `${RESOURCE_WORKSPACE_BASE_PATH}/${encodeResourceRouteSegment(clientResourceId)}`;
  return resourceConfigurationId
    ? `${basePath}/configurations/${encodeResourceRouteSegment(resourceConfigurationId)}/configure`
    : `${basePath}/configure`;
};
